import type { PollVoter } from '@/containers/DevToolsNew/CommunicationBoard/PollResults/types'
import { VoterComment, VoterDate, VoterName, VoterRow, VoterScore } from './styled-components'

interface PollVoterRowProps {
  voter: PollVoter
}

const PollVoterRow = ({ voter: { name, team, face, comment, commentHidden, votedAt } }: PollVoterRowProps) => (
  <VoterRow>
    <VoterName>{name}</VoterName>
    <span>{team}</span>
    <VoterScore $colorKey={face.colorKey}>
      <face.Icon size={16} />
      {face.label}
    </VoterScore>
    <VoterDate>{votedAt}</VoterDate>
    <VoterComment hidden={commentHidden}>« {comment} »</VoterComment>
  </VoterRow>
)

export default PollVoterRow
